import { defineStore } from 'pinia'
import backendHandler from '@/BackendAPI.js'
import { useInstanceStore } from '@/store/backendInstances.js'

export const useAdmiralStore = defineStore('admiral', {
  state: () => ({}),
  persist: false,
  share: {
    enable: true,
    initialize: true,
  },
  getters: {
    getAdmiralInstance: () => useInstanceStore().getAdmiral,
  },
  actions: {
    async queryVMSInstances(payload) {
      if (!this.getAdmiralInstance) throw new Error('No Admiral Instance created!')
      const vmsInstanceResponse = await backendHandler.post(this.getAdmiralInstance.globalUniqueIdentifier, {
        path: '/api/vmsInstances/query',
        data: payload,
      })
      if (!vmsInstanceResponse.ok) return null
      return vmsInstanceResponse.data
    },

    async getGlobalUniqueIdentifierForVmsInstanceId(vmsInstanceId) {
      if (!this.getAdmiralInstance) throw new Error('No Admiral Instance created!')
      const response = await backendHandler.get(this.getAdmiralInstance.globalUniqueIdentifier, { path: '/api/vmsInstances/' + vmsInstanceId })
      if (!response.ok) return null
      return response.data.globalUniqueIdentifier
    },

    async updateVMSInstance(vmsInstanceId, payload) {
      if (!this.getAdmiralInstance) throw new Error('No Admiral Instance created!')
      const updateResponse = await backendHandler.patch(this.getAdmiralInstance.globalUniqueIdentifier, {
        path: '/api/vmsInstances/' + vmsInstanceId,
        data: { updates: payload },
      })
      return updateResponse.ok
    },
    async generateDiscoveryString(globalUniqueIdentifier) {
      if (!this.getAdmiralInstance) throw new Error('No Admiral Instance created!')
      const discoveryStringResponse = await backendHandler.get(this.getAdmiralInstance.globalUniqueIdentifier, {
        path: '/api/vmsInstances/discoveryString/' + globalUniqueIdentifier,
      })
      if (!discoveryStringResponse.ok) return null
      return discoveryStringResponse.data
    },
  },
})
